import FinancialDetails from '@/pages/financial-details/FinancialDetails';

export default FinancialDetails;
